
















import { defineComponent, watch, ref } from "@vue/composition-api";
import Navigation from "@/components/Navigation.vue";
import useUser from "@/composables/user";
import useBusinessLogin from "@/composables/business-login";

export default defineComponent({
  components: {
    Navigation
  },
  setup(props: any, context: any) {
    const { initAuthentication, isAuthenticated } = useUser();
    const { setBusinessLoginParams, hasBusinessLogin } = useBusinessLogin();
    const router = context.root.$router;
    const authLoading = ref(true);

    // Check for business-login parameter in URL
    const checkBusinessLoginParam = () => {
      const businessId = router.currentRoute.query['businessId'] as string;
      const operation = router.currentRoute.query['op'] as string | undefined;
      const addonId = router.currentRoute.query['addonId'] as string | undefined;
      const language = (router.currentRoute.query['lang'] as string | undefined) || undefined;
      if (businessId) {
        setBusinessLoginParams(businessId, language || 'cs', (operation as any) || null, addonId || null);
      }
    };

    initAuthentication().then(() => {
        if (isAuthenticated.value) {
          if (router.currentRoute.name == "login") {
            router.push({ name: "home" });
          }
        } else if (router.currentRoute.name != "login") {
          router.push({ name: "login", query: { returnUrl: router.currentRoute.fullPath } });
        }

        setTimeout(() => {
          authLoading.value = false;
        }, 1000);
    })
    
    // Check for business-login parameter in URL (for both authenticated and non-authenticated users)
    checkBusinessLoginParam();   

    return {
      authLoading,
      isAuthenticated,
      hasBusinessLogin
    };
  },
});
